import React, { FC } from 'react'
import { useHistory } from 'react-router'
import { Box } from 'transfix-ui/core'
import { useTrackConversionContext } from 'apps/fleet-planner/context/track-conversion-source'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks'
import { Rate } from 'apps/fleet-planner/pages/marketplace/Rate'
import { AuctionShipment } from 'apps/fleet-planner/types'
import {
  getAuctionshipmentStops,
  getMarketplaceValues,
} from 'apps/fleet-planner/utils/marketplaceHelpers'
import { Button, TableRow, TableCell } from 'transfix-ui'
import { MarketplaceTableRowLocation } from './MarketplaceTableRowLocation'

interface IMarketplaceReloadsRowProps {
  shipment: AuctionShipment
}

export const MarketplaceReloadsRow: FC<IMarketplaceReloadsRowProps> = ({ shipment }) => {
  const { trackEvent } = useFMSAnalytics()
  const { id } = shipment || {}
  const { setTrackConversion } = useTrackConversionContext()
  const { targetRate, totalMiles } = getMarketplaceValues(shipment)
  const { stops } = getAuctionshipmentStops(shipment)
  const history = useHistory()
  const viewLoadHandler = () => {
    setTrackConversion('web', 'reloads_post_rate_con_modal')
    trackEvent('Reload', 'CLICKED_VIEW_LOAD_FROM_RELOADS_MODAL')
    history.push(`/book/${id}`)
  }

  return (
    <TableRow>
      <TableCell className='pl0'>
        <Rate totalMiles={totalMiles} targetRate={targetRate} />
      </TableCell>
      <TableCell>
        <MarketplaceTableRowLocation stops={stops} />
      </TableCell>
      <TableCell>
        <Box style={{ textAlign: 'right', paddingRight: '12px' }}>
          <Button color='primary' onClick={viewLoadHandler} className='nowrap'>
            View Load
          </Button>
        </Box>
      </TableCell>
    </TableRow>
  )
}
